// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"2d3e62de","85":"c6826234","109":"36a57660","151":"57c5ea92","417":"04e96d63","453":"447603d4","634":"24021aad","646":"1beebd3f","752":"72314f30","874":"d3e82bb1"}[chunkId] + ".chunk.js";
};